import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";

const CreateTicket = () => {
  const { user } = useContext(AuthContext);

  const [form, setForm] = useState({
    title: "",
    priority: "Low",
    room: "",
    category_id: "1",
    description: "",
  });

  const [popup, setPopup] = useState({
    show: false,
    text: "",
    success: true,
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const showPopup = (text, success = true) => {
    setPopup({
      show: true,
      text,
      success,
    });

    setTimeout(() => {
      setPopup({
        show: false,
        text: "",
        success: true,
      });
    }, 3000);
  };

  const createIncident = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/incident.php`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...form,
            created_by: user.id,
          }),
        },
      );

      const data = await response.json();

      if (data.success) {
        showPopup("Incident je bil uspešno ustvarjen.", true);

        setForm({
          title: "",
          priority: "Low",
          room: "",
          category_id: "1",
          description: "",
        });
      } else {
        showPopup(data.message, false);
      }
    } catch (error) {
      showPopup("Server error.", false);
    }
  };

  return (
    <div className="bg-gray-50 p-5 m-2 rounded-2xl relative">
      <h1 className="text-3xl font-bold mb-5">Ustvari incident</h1>

      <div className="bg-white rounded-2xl shadow p-6 space-y-4">
        <input
          name="title"
          value={form.title}
          onChange={handleChange}
          placeholder="Ime incidenta"
          className="w-full border p-3 rounded-xl"
        />

        <select
          name="priority"
          value={form.priority}
          onChange={handleChange}
          className="w-full border p-3 rounded-xl"
        >
          <option value="Low">Nizka prioriteta</option>
          <option value="Medium">Srednja prioriteta</option>
          <option value="High">Visoka prioriteta</option>
        </select>

        <input
          name="room"
          value={form.room}
          onChange={handleChange}
          placeholder="Predavalnica / Učilnica"
          className="w-full border p-3 rounded-xl"
        />

        <select
          name="category_id"
          value={form.category_id}
          onChange={handleChange}
          className="w-full border p-3 rounded-xl"
        >
          <option value="1">Strojna oprema</option>
          <option value="2">Programska oprema</option>
          <option value="3">Internet</option>
        </select>

        <textarea
          rows="5"
          name="description"
          value={form.description}
          onChange={handleChange}
          placeholder="Opis incidenta..."
          className="w-full border p-3 rounded-xl"
        ></textarea>

        <button
          onClick={createIncident}
          className="bg-midBlue text-white px-6 py-3 rounded-xl font-bold hover:bg-primary"
        >
          Create Incident
        </button>
      </div>

      {popup.show && (
        <div className="fixed top-5 right-5 z-50">
          <div
            className={`px-6 py-4 rounded-xl shadow-xl text-white font-semibold ${
              popup.success ? "bg-green-500" : "bg-red-500"
            }`}
          >
            {popup.text}
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateTicket;
